const dataValidation = [
  {
    desc: "dataValidation map boundaries",
    coord: [
      { N: 9685147.555, E: 396134.256 },
      { N: 9685144.228, E: 396166.089 },
      { N: 9685142.191, E: 396198.072 },
      { N: 9685130.08, E: 396234.735 },
      { N: 9685107.221, E: 396266.491 },
      { N: 9685093.111, E: 396272.368 },
      { N: 9685079.914, E: 396277.864 },
      { N: 9685070.643, E: 396285.302 },
      { N: 9685053.98, E: 396298.669 },
      { N: 9685033.391, E: 396322.335 },
      { N: 9685032.417, E: 396328.545 },
      { N: 9685027.201, E: 396361.771 },
      { N: 9685025.658, E: 396405.809 },
      { N: 9685016.527, E: 396448.112 },
      // /*      
      { N: 9685000.603, E: 396466.574 },
      { N: 9684999.273, E: 396468.116 },
      { N: 9684971.675, E: 396495.116 },
      { N: 9684964.503, E: 396520.755 },
      { N: 9684963.832, E: 396554.631 },
      { N: 9684961.5, E: 396598.273 },
      { N: 9684958.414, E: 396635.546 },
      { N: 9684958.136, E: 396658.247 },
      { N: 9684958.006, E: 396688.893 },
      { N: 9684938.992, E: 396688.723 },
      { N: 9684932.781, E: 396703.429 },
      { N: 9684916.223, E: 396720.104 },
      { N: 9684894.574, E: 396733.721 },
      { N: 9684888.436, E: 396741.267 },
      { N: 9684875.613, E: 396757.033 },
      { N: 9684858.668, E: 396784.42 },
      { N: 9684841.512, E: 396824.217 },
      { N: 9684829.515, E: 396839.192 },
      { N: 9684811, E: 396876.102 },
      { N: 9684788.447, E: 396910.746 },
      { N: 9684769.223, E: 396934.455 },
      { N: 9684747.551, E: 396970.574 },
      { N: 9684738.537, E: 396995.95 },
      { N: 9684720.772, E: 397034.072 },
      { N: 9684699.896, E: 397078.919 },
      { N: 9684680.757, E: 397107.344 },
      { N: 9684671.525, E: 397125.755 },
      { N: 9684658.437, E: 397147.585 },
      { N: 9684652.813, E: 397165.781 },
      { N: 9684650.56, E: 397172.96 },
      { N: 9684640.407, E: 397191.636 },
      { N: 9684631.358, E: 397223.778 },
      { N: 9684627.498, E: 397251.144 },
      { N: 9684620.362, E: 397288.056 },
      { N: 9684614.084, E: 397331.701 },
      { N: 9684607.434, E: 397359.316 },
      { N: 9684607.207, E: 397359.815 },
      { N: 9684591.631, E: 397377.739 },
      { N: 9684568.764, E: 397399.578 },
      { N: 9684557.667, E: 397431.823 },
      { N: 9684548.687, E: 397457.119 },
      { N: 9684545.157, E: 397482.909 },
      { N: 9684539.454, E: 397508.873 },
      { N: 9684530.004, E: 397529.664 },
      { N: 9684519.95, E: 397539.264 },
      { N: 9684515.168, E: 397562.303 },
      { N: 9684502.985, E: 397619.159 },
      { N: 9684485.343, E: 397682.905 },
      { N: 9684485.044, E: 397716.32 },
      { N: 9684478.962, E: 397737.556 },
      { N: 9684476.319, E: 397746.785 },
      { N: 9684468.458, E: 397784.48 },
      { N: 9684475.394, E: 397814.253 },
      { N: 9684475.613, E: 397814.584 },
      { N: 9684495.336, E: 397844.364 },
      { N: 9684507.2, E: 397878.473 },
      { N: 9684508.418, E: 397915.598 },
      { N: 9684503.04, E: 397929.243 },
      { N: 9684499.751, E: 397937.59 },
      { N: 9684491.895, E: 397982.03 },
      { N: 9684490.172, E: 398012.384 },
      { N: 9684489.709, E: 398020.54 },
      { N: 9684505.368, E: 398055.016 },
      { N: 9684520.391, E: 398091.503 },
      { N: 9684534.781, E: 398119.986 },
      { N: 9684549.247, E: 398158.526 },
      { N: 9684556.378, E: 398194.622 },
      { N: 9684567.914, E: 398219.552 },
      { N: 9684588.372, E: 398237.443 },
      { N: 9684609.304, E: 398263.213 },
      { N: 9684632.608, E: 398294.536 },
      { N: 9684654.542, E: 398308.071 },
      { N: 9684694.187, E: 398327.812 },
      { N: 9684727.732, E: 398336.513 },
      { N: 9684753.068, E: 398343.45 },
      { N: 9684759.715, E: 398367.035 },
      { N: 9684768.018, E: 398387.658 },
      { N: 9684776.443, E: 398406.566 },
      { N: 9684778.711, E: 398438.827 },
      { N: 9684785.452, E: 398480.081 },
      { N: 9684796.199, E: 398505.81 },
      { N: 9684820.609, E: 398531.627 },
      { N: 9684854.568, E: 398566.116 },
      { N: 9684875.503, E: 398594.266 },
      { N: 9684894.077, E: 398601.798 },
      { N: 9684910.144, E: 398608.313 },
      { N: 9684939.055, E: 398628.731 },
      { N: 9684960.775, E: 398653.707 },
      { N: 9684981.605, E: 398668.39 },
      { N: 9684981.954, E: 398688.929 },
      { N: 9684982.117, E: 398698.52 },
      { N: 9684984.422, E: 398736.191 },
      { N: 9684988.084, E: 398760.008 },
      { N: 9684994.422, E: 398791.344 },
      { N: 9685006.81, E: 398809.089 },
      { N: 9685029.174, E: 398829.402 },
      { N: 9685065.476, E: 398832.151 },
      { N: 9685097.513, E: 398833.468 },
      { N: 9685112.825, E: 398833.097 },
      { N: 9685148.434, E: 398825.983 },
      { N: 9685178.698, E: 398810.241 },
      { N: 9685199.817, E: 398800.267 },
      { N: 9685237.07, E: 398780.441 },
      { N: 9685272.171, E: 398762.164 },
      { N: 9685299.558, E: 398742.765 },
      { N: 9685324.223, E: 398724.037 },
      { N: 9685344.418, E: 398707.089 },
      { N: 9685344.418, E: 398656.46 },
      { N: 9685215.404, E: 398656.46 },
      { N: 9685215.404, E: 398544.254 },
      { N: 9685259.193, E: 398544.254 },
      { N: 9685333.156, E: 398522.199 },
      { N: 9685333.156, E: 398476.538 },
      { N: 9685318.989, E: 398476.538 },
      { N: 9685318.989, E: 398443.777 },
      { N: 9685162.717, E: 398419.872 },
      { N: 9685135.567, E: 398379.543 },
      { N: 9685086.045, E: 398379.543 },
      { N: 9685040.519, E: 398329.428 },
      { N: 9685040.519, E: 398288.954 },
      { N: 9685053.817, E: 398288.954 },
      { N: 9685053.817, E: 398303.355 },
      { N: 9685138.753, E: 398303.355 },
      { N: 9685254.805, E: 398269.558 },
      { N: 9685384.461, E: 398269.558 },
      { N: 9685384.461, E: 398222.49 },
      { N: 9685323.174, E: 398162.481 },
      { N: 9685293.77, E: 398109.985 },
      { N: 9685293.77, E: 398095.175 },
      { N: 9685366.765, E: 398095.175 },
      { N: 9685366.765, E: 397755.176 },
      { N: 9685504.447, E: 397755.176 },
      { N: 9685631.641, E: 397484.477 },
      { N: 9685988, E: 397410.548 },
      { N: 9685988, E: 396894.199 },
      { N: 9685971.426, E: 396889.848 },
      { N: 9685942.909, E: 396868.294 },
      { N: 9685921.277, E: 396841.488 },
      { N: 9685901.919, E: 396810.955 },
      { N: 9685893.519, E: 396782.243 },
      { N: 9685879.385, E: 396756.225 },
      { N: 9685861.6, E: 396718.946 },
      { N: 9685853.978, E: 396676.348 },
      { N: 9685847.732, E: 396647.546 },
      { N: 9685836.659, E: 396616.214 },
      { N: 9685825.098, E: 396581.553 },
      { N: 9685813.332, E: 396556.326 },
      { N: 9685799.897, E: 396531.74 },
      { N: 9685798.141, E: 396524.803 },
      { N: 9685789.514, E: 396490.731 },
      { N: 9685783.669, E: 396469.07 },
      { N: 9685764.302, E: 396427.032 },
      { N: 9685749.984, E: 396398.722 },
      { N: 9685735.052, E: 396363.182 },
      { N: 9685716.873, E: 396327.095 },
      { N: 9685701.02, E: 396285.248 },
      { N: 9685688.8, E: 396254.516 },
      { N: 9685684.214, E: 396235.106 },
      { N: 9685680.072, E: 396217.572 },
      { N: 9685656.785, E: 396185.511 },
      { N: 9685628.839, E: 396173.456 },
      { N: 9685582.217, E: 396173.456 },
      { N: 9685582.217, E: 396350.068 },
      { N: 9685301.132, E: 396350.068 },
      { N: 9685301.132, E: 396190.973 },
      { N: 9685225.133, E: 396129.094 },
      { N: 9685147.879, E: 396129.094 },
      { N: 9685147.752, E: 396132.375 },   
      //  */   
    ],
    coordGPS: [],
  },
];

export default dataValidation;
